<template lang="pug">
.plan-overview
  alert-info(v-if="success").m-b-4: h1 {{$t('settings.plan.subscription.callback-success') }}
  CardMinimal(:title="$t('settings.plan.subscription.header')", v-if="plan")
    .p-a-4
      .plan-overview-container
        .plan-overview-summary
          .d-f.header.ai-c
            h2 {{ product }}
            template(v-if="trial")
              Tag(:text="$t(`settings.plan.subscription.trial_ends_at`)+trial.endsAt", :class="{'capitalize': true}").mr-2
            template(v-if="cancelled")
              Tag(:text="$t(`settings.plan.subscription.canceled_ends_at`)+cancelled.cancelAt", :class="{'capitalize': true}").mr-2
            template(v-else)
              Tag(:text="$t(`settings.plan.subscription.active`)", :class="{'capitalize': true}")
            div.ml-a.price {{ plan.billing_amount }}{{ plan.billing_currency.toUpperCase() }} / {{ plan.billing_interval }}
      Button(@click="getManagePlanLink").very-blue.rounded.m-t-4 {{ $t('settings.plan.manage_subscription') }}
  template(v-else)
    div(v-html="$t('settings.plan.no_plan')")
</template>

<script>

import moment from 'moment';

import Tag from '@/components/tag.vue';

export default {
  components: {
    Tag,
  },
  data() {
    return {
      trial: null,
      cancelled: null,
      status: null,
      plan: null,
      product: null,
      billingInfo: null,
      success: false,
    };
  },

  watch: {
    accountSettings: {
      immediate: true,
      handler(settings) {
        if (settings && settings.stripe_plan) {
          const { stripe_plan: plan } = settings;
          if (plan.subscription_id === '') {
            this.$router.push('/settings/plan');
            return;
          }

          this.plan = plan;

          const cancelAt = moment(plan.subscription_cancel_at);
          const canceledAt = moment(plan.subscription_canceled_at);
          const subscriptionEndsAt = moment(plan.subscription_ends_at);
          const endsAt = moment(plan.trial_ends_at);

          if (plan.subscription_status === 'trialing') {
            this.trial = {
              endsAt: endsAt.format('YYYY-MM-DD'),
            };
          }

          if (cancelAt.diff(Date.now()) > 0) {
            this.cancelled = {
              cancelAt: cancelAt.format('YYYY-MM-DD'),
              canceledAt: canceledAt.format('YYYY-MM-DD'),
            };
          }

          this.billingInfo = `${plan.billing_amount} ${plan.billing_currency}/${
            plan.billing_interval
          }, next invoice ${subscriptionEndsAt.format('YYYY-MM-DD')}`;
          this.product = plan.product || 'Standard';
          this.status = plan.subscription_status;
          this.subscriptionEndsAt = subscriptionEndsAt.format('YYYY-MM-DD');
        }
      },
    },
    managePlanLink: {
      immediate: true,
      handler(url) {
        if (url) {
          window.location.href = url;
        }
      },
    },
  },

  computed: {
    managePlanLink() {
      return this.$store.getters['Plan/managePlanLink'];
    },
  },
  methods: {
    async getManagePlanLink() {
      const success = await this.$store.dispatch('Plan/getManagePlanLink', '/settings/billing');
      if (!success) {
        swal({
          title: 'An error occured',
          text:
            'For some reason we could not open the plan management page right now',
          icon: 'error',
        });
      }
    },
  },
  async mounted() {
    if (this.$route.params && this.$route.params.status) {
      if (this.$route.params.status === 'success') {
        this.success = true;
      }
    }
    await this.$store.dispatch('AccountManager/getAccountSettings');
  },
};
</script>

<style lang="scss" scoped>
.plan-overview-summary {

  .header {
    h2 {
      font-size: 1.5rem;
      text-transform: capitalize
    }

    .tag {
      margin: 0 1rem;
    }

    .price {
      font-size: 1.25rem;
    }
  }
}
</style>
